import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskCpf, maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';


import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles';
import PasswordInput from '../ReusableComponents/PasswordInput';
import { RadioGroup } from '@mui/material';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
class EditarAluno extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: true,
      roles: [],
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      cpf: '',
      nascimento: moment().subtract(16, 'years'),
      imagem: '',
      loading_save: false,
      msgErro: '',
      loading_image: false,
      faculdade: { name: '' },
      path_image: undefined,
      numero_inscricao: '',
      accessibility: false,
      type_supervisor: 'none',
      need_audio_speak: false,
      need_zoom: false
    };


  }

  get_candidato(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_candidato/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false, faculdade: resp.aluno.faculdade,
            name: resp.aluno.name,
            email: resp.aluno.email,
            accessibility: resp.aluno.accessibility,
            type_supervisor: resp.aluno.type_supervisor,
            need_audio_speak: resp.aluno.need_audio_speak,
            need_zoom: resp.aluno.need_zoom,

            cpf: resp.aluno.cpf,
            nascimento: moment(resp.aluno.nascimento),
            numero_inscricao: resp.aluno.numero_inscricao,
            path_image: resp.aluno.imagem != null ? resp.aluno.imagem : undefined


          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }



  salvar(e) {
    e.preventDefault();
    this.setState({ loading_save: true, msgErro: '' });
    let form = new FormData();
    form.append('name', this.state.name);
    form.append('email', this.state.email);
    form.append('password', this.state.password);
    form.append('password_confirmation', this.state.password_confirmation);
    form.append('imagem', this.state.imagem);
    form.append('cpf', this.state.cpf);
    form.append('numero_inscricao', this.state.numero_inscricao);
    form.append('accessibility', this.state.accessibility);
    form.append('type_supervisor', this.state.type_supervisor);
    form.append('need_audio_speak', this.state.need_audio_speak);
    form.append('need_zoom', this.state.need_zoom);

    form.append('nascimento', this.state.nascimento.format('YYYY-MM-DD HH:mm:ss'));

    form.append('candidato_id', this.props.match.params.id);



    fetch(`${URL}api/faculdade/update_candidato`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
      },
      body: form
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          window.scrollTo(500, 0);

          this.setState({ loading_save: false, msgErro: erro });
        } else
        {

          this.setState({ loading_save: false });
          this.props.history.push({
            pathname: `/instituicao/show/${this.state.faculdade.id}`,

            search: '?' + new URLSearchParams({ tab: '4' }).toString()
          });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

      }

    }).
    catch((err) => {
      console.log(err);
      this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
    });
  }


  componentDidMount() {
    this.get_candidato(this.props.match.params.id);
  }





  change_tipo(event) {
    this.setState({ tipo: event.target.value });
  }


  render() {
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={`/instituicao/show/${this.state.faculdade.id}`} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">


                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("ui_editar_candidato_de3b0830")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Edite um candidato da {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_da_instituicao") : this.context.t("legacy_do_processo")} {this.state.faculdade.name}</p>
                            <br />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <Form.Label>Imagem do candidato </Form.Label>
                                    <ImageLoaderInput path={this.state.path_image} width_='100%' height_='200px' ImageChange={(image) => this.setState({ imagem: image })} />
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_name")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_nome_do_aluno")}
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_email")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("label_email")}
                        value={this.state.email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    {<InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_o_candidato_precisa_de_alguma_funcao_de_acessibili_9ef2ad9d")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.accessibility}
                        onChange={(e) => {
                          this.setState({ accessibility: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {
                          this.setState({ accessibility: true });
                        }} control={<Radio checked={this.state.accessibility == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ accessibility: false, type_supervisor: 'none', need_zoom: false, need_audio_speak: false });

                        }} control={<Radio checked={this.state.accessibility == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                        
                                    </InputGroup>}
                                    {this.state.accessibility && <InputGroup style={{ flexWrap: 'wrap' }}>

                                    <div className="flex fdcolumn flex1 margin-bottom " style={{ marginRight: 1, minWidth: 250 }}>
                                            <Form.Label>{this.context.t("ui_e_necessario_um_fiscal_supervisor_77284eb8")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.accessibility}
                        onChange={(e) => {



                          // this.setState({ type_supervisor: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {this.setState({ type_supervisor: 'libras' });}} control={<Radio checked={this.state.type_supervisor == 'libras'} value={'libras'} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {console.log(e.target.value);
                            this.setState({ type_supervisor: 'none' });

                          }} control={<Radio checked={this.state.type_supervisor == 'none'} value={'none'} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                        <div className="flex fdcolumn flex1 margin-bottom" style={{ marginRight: 1, minWidth: 250 }}>
                                            <Form.Label>{this.context.t("ui_habilitar_opcao_de_ouvir_questao_redacao_744ae16d")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.accessibility}
                        onChange={(e) => {



                          // this.setState({ type_supervisor: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {this.setState({ need_audio_speak: true });}} control={<Radio checked={this.state.need_audio_speak == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {console.log(e.target.value);
                            this.setState({ need_audio_speak: false });

                          }} control={<Radio checked={this.state.need_audio_speak == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                        <div className="flex fdcolumn flex1 margin-bottom" style={{ marginRight: 1, minWidth: 250 }}>
                                            <Form.Label>{this.context.t("ui_habilitar_possibilidade_de_ampliar_questao_redacao_cb06350b")}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.need_zoom}
                        onChange={(e) => {



                          // this.setState({ type_supervisor: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {this.setState({ need_zoom: true });}} control={<Radio checked={this.state.need_zoom == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {console.log(e.target.value);
                            this.setState({ need_zoom: false });

                          }} control={<Radio checked={this.state.need_zoom == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                        </InputGroup>}

                                    <InputGroup>
                                        <PasswordInput
                      label={this.context.t("password")}
                      placeholder={this.context.t("placeholder_password")}
                      className="flex1"
                      value={this.state.password}
                      OnChangeText={(e) => this.setState({ password: e.target.value })}
                      // title="Coloque a senha do usuário"
                    />
                                    </InputGroup>

                                    <InputGroup>
                                        <PasswordInput
                      label={this.context.t("label_password_confirmation")}
                      placeholder={this.context.t("legacy_digite_a_confirmacao_de_senha")}
                      className="flex1"
                      value={this.state.password_confirmation}
                      OnChangeText={(e) => this.setState({ password_confirmation: e.target.value })}
                      // title="Coloque a senha do usuário"
                    />
                                    </InputGroup>

                                    <MuiPickersUtilsProvider utils={MomentUtils}>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>{`${this.context.t("legacy_data_de_nascimento")} `}</Form.Label>
                                                <DatePicker
                          autoOk
                          margin="normal"
                          style={{ width: '100%' }}
                          invalidDateMessage={this.context.t("ui_data_invalida_76fc5825")}
                          ampm={false}
                          maxDate={moment()}
                          id="time-picker"
                          cancelLabel={this.context.t("legacy_cancelar")}
                          clearLabel={this.context.t("action_clear")}
                          format="DD/MM/YYYY"
                          value={this.state.nascimento}
                          onChange={(date) => {this.setState({ nascimento: date });}} />


                                            </div>

                                        </InputGroup>
                                    </MuiPickersUtilsProvider>
                                    <InputGroup>

                    <div className="flex fdcolumn flex1 margin-bottom">
    <Form.Label>{`${this.context.t("legacy_numero_de_inscricao")} `}<Attention /></Form.Label>
    <Input
                        placeholder={this.context.t("legacy_numero_de_inscricao")}
                        value={this.state.numero_inscricao}
                        onChange={(e) => this.setState({ numero_inscricao: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                    </div>
                  </InputGroup>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("legacy_cpf")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_cpf")}
                        value={this.state.cpf}
                        onChange={(e) => this.setState({ cpf: maskCpf(e.target.value) })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                      <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                      </Link> */}
                                        <DefaultButton
                      bg="secondary"
                      text={this.context.t("back")}
                      icon={<RiArrowGoBackLine />}
                      search={'?' + new URLSearchParams({ tab: 4 }).toString()}
                      to={`/instituicao/show/${this.state.faculdade.id}`} />

                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                      {this.state.loading ? <Spinner /> : ""}
                      Registrar usuário
                      </Button> */}
                                        <DefaultButton
                      type="submit"
                      bg="confirm"
                      text={this.context.t("legacy_salvar_aluno")}
                      disabled={this.state.loading_image == true}
                      loadingtext="Salvando aluno"
                      loading={this.state.loading_save} />

                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                                        <div className="spinner-border text-primary" role="status">
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status">
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token,
  user: state.AppReducer.user

});


export default connect(mapsStateToProps, { logout })(EditarAluno);